import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => {
			return (
				<p className="typography typography--subtle-big typography--secondary">
					{children}
				</p>
			);
		},
	},
};

const ContactForm = ({ title, description }) => {
	return (
		<section className="contact-form">
			<div className="section__wrap">
				<h2 className="typography typography--h2 typography--secondary">
					{title}
				</h2>
				<div className="typography typography--subtle-big typography--secondary contact-form__description">
					{description &&
						typeof description === 'object' &&
						renderRichText(description, options)}
					{description && typeof description === 'string' && description}
				</div>
				<iframe
					src={`${process.env.GATSBY_MAGENTO_PROD_BASE}/iframe/form/get/code/contact-us`}
					frameBorder="0"
					className="contact-form__iframe"
					scrolling="no"
				/>
			</div>
		</section>
	);
};

ContactForm.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.oneOfType([
		PropTypes.shape({
			raw: PropTypes.string,
		}),
		PropTypes.string,
	]).isRequired,
};

export default ContactForm;
